import axios from 'axios';
import * as config from 'src/config';
import { FETCH_STATUS } from 'src/constants';
import { TManifestFilters, TManifestNonSession, TManifestSession } from 'src/reducers/manifest';

export const SET_MANIFEST_SESSION = 'manifest/SET_MANIFEST_SESSION';
export const SET_MANIFEST_NON_SESSION = 'manifest/SET_MANIFEST_NON_SESSION';
export const SET_MANIFEST_SESSION_OVERVIEW = 'manifest/SET_MANIFEST_SESSION_OVERVIEW';
export const SET_MANIFEST_SERVICE_APPLETS = 'manifest/SET_MANIFEST_SERVICE_APPLETS';
export const SET_MANIFEST_FILTERS = 'manifest/SET_MANIFEST_FILTERS';
export const CLEAR_MANIFEST_SERVICE_APPLETS = 'manifest/CLEAR_MANIFEST_SERVICE_APPLETS';
export const CLEAR_MANIFEST = 'manifest/CLEAR_MANIFEST';

export const setManifestSession = (value: Partial<TManifestSession>) => {
  return (dispatch) => {
    dispatch({ type: SET_MANIFEST_SESSION, data: value });
  };
};

export const setManifestNonSession = (value: Partial<TManifestNonSession>) => {
  return (dispatch) => {
    dispatch({ type: SET_MANIFEST_NON_SESSION, data: value });
  };
};

export const setManifestSessionOverview = (value) => {
  return (dispatch) => {
    dispatch({ type: SET_MANIFEST_SESSION_OVERVIEW, data: value });
  };
};

export const setManifestServiceApplets = (value) => {
  return (dispatch) => {
    dispatch({ type: SET_MANIFEST_SERVICE_APPLETS, data: value });
  };
};

export const setManifestFilters = (value: Partial<TManifestFilters>) => {
  return (dispatch) => {
    dispatch({ type: SET_MANIFEST_FILTERS, data: value });
  };
};

export const clearManifestServiceApplets = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_MANIFEST_SERVICE_APPLETS });
  };
};

export const clearManifest = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_MANIFEST });
  };
};
